const splitFileName = (fileName) => {
  let dotIndex = fileName.lastIndexOf(".");

  return {
    name: fileName.substr(0, dotIndex),
    extension: fileName.substr(dotIndex + 1),
  };
};

const createSourceSetString = (publicURL, filenameSet) => {
  return (
    publicURL +
    "/" +
    filenameSet.name +
    "." +
    filenameSet.extension +
    " 1x, " +
    publicURL +
    "/" +
    filenameSet.name +
    "@2x." +
    filenameSet.extension +
    " 2x, " +
    publicURL +
    "/" +
    filenameSet.name +
    "@3x." +
    filenameSet.extension +
    " 3x"
  );
};

const embedInLink = (url, title, openInNewWindow, element) => {
  return (
    <a
      href={url}
      title={title}
      target={openInNewWindow ? "_blank" : ""}
      rel={"noreferrer"}
    >
      {element}
    </a>
  );
};

const ResponsiveImage = ({
  publicURL,
  fileName,
  description,
  customClassName,
  linkURL,
  linkTitle,
  openInNewWindow,
}) => {
  const desc = description || fileName;
  const className = customClassName || "";

  if (typeof fileName === "undefined") {
    return null;
  }

  const returnedImage = () => {
    return (
      <img
        src={publicURL + "/" + fileName}
        srcSet={createSourceSetString(publicURL, splitFileName(fileName))}
        alt={desc}
        className={className}
      />
    );
  };

  if (linkURL && typeof linkURL === "string") {
    return embedInLink(linkURL, linkTitle, openInNewWindow, returnedImage());
  }

  return returnedImage();
};

export default ResponsiveImage;
